import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import kehilaMigrationWizardStore from 'store/kehilaMigrationWizard.store'
import { Cards, Card, RowSplit, KeyButton, PlainButton, Banner, FailRow, Note } from '../KehilaMigrationWizard.styles'

const ReportStep: FC = () => {
  const store = kehilaMigrationWizardStore
  const { t } = useTranslation('kehilaMigration')
  const status = store.importStatus
  // Only reflects the most recent log entries 
  const failedEntries = (status?.recentEntries ?? []).filter(e => e.status === 'Failed')

  return (
    <>
      <Cards style={{ marginBottom: 18 }}>
        <Card><div className='l'>{t`import_imported`}</div><div className='n'>{status?.imported ?? 0}</div></Card>
        <Card><div className='l'>{t`import_skipped`}</div><div className='n'>{status?.skipped ?? 0}</div></Card>
        <Card><div className='l'>{t`import_failed`}</div><div className='n'>{status?.failed ?? 0}</div></Card>
      </Cards>
      {status && status.failed > 0 ? (
        <>
          {failedEntries.map(entry => (
            <FailRow key={entry.id}>{entry.protocolOldId} — {entry.statusDetails}</FailRow>
          ))}
          <RowSplit>
            <KeyButton onClick={store.retryFailed}>{t('report_retry', { num: status.failed })}</KeyButton>
            <PlainButton onClick={store.downloadLog}>{t`report_downloadLog`}</PlainButton>
          </RowSplit>
        </>
      ) : (
        <>
          <Banner kind='ok'>{t`report_allLanded`}</Banner>
          <RowSplit style={{ marginTop: 14 }}>
            <PlainButton onClick={store.downloadLog}>{t`report_downloadLog`}</PlainButton>
          </RowSplit>
        </>
      )}
      <Note>
        {t`report_note`}
      </Note>
    </>
  )
}

export default observer(ReportStep)
